import ModalButton  from './ModalButton ';

export default ModalButton ;